/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ItemTileCarousel_viewer">;
    readonly " $refType": "SharedItemTile_viewer";
};
export type SharedItemTile_viewer$data = SharedItemTile_viewer;
export type SharedItemTile_viewer$key = {
    readonly " $data"?: SharedItemTile_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedItemTile_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ItemTileCarousel_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ]
    }
  ]
};
(node as any).hash = '1e03313379129888e41716bf223f0980';
export default node;
